import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { ChartColorCheckboxOptionModel } from '../../Forms/models/chart-color-checkbox-option.model';

export class ChartColorCheckboxesFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    options: ChartColorCheckboxOptionModel[];
    binary?: boolean;
    errorMessage?: string;
    headingId?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        options: ChartColorCheckboxOptionModel[],
        binary?: boolean,
        errorMessage?: string,
        headingId?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.options = options;
        this.binary = !!binary;
        this.errorMessage = errorMessage;
        this.headingId = headingId;
    }
}
